import { render, staticRenderFns } from "./EmailServer.vue?vue&type=template&id=0d1b65d9&"
import script from "./EmailServer.vue?vue&type=script&lang=js&"
export * from "./EmailServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports